import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import LayoutThumbnail from 'components/LayoutThumbnail/Image';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Slot = styled.div`
	position: relative;
	height: 200px;
	border: 2px solid ${props => props.active ? '#4A90E2' : 'rgba(0,0,0,0.05)'};
	cursor: pointer;
	margin-bottom: 16px;
	transition: border 0.2s ease-out;

	&:hover {
		border: 2px solid #4A90E2;
	}
`;

const imageLayouts = [ // Layouts can be found in the brochure.css
	[],// zero images
	[],// one image only has default layout
	['b', 'c'], // Two images has default, b and c
	['b', 'c'], // Three images has default, b and c
	['b', 'c'], // Four images has default, b and c
];

class Layout extends React.Component {
	state = {
	  layout: this.props.layout,
	}

	shouldComponentUpdate(nextProps) {
	  return this.props.layout !== nextProps.layout;
	}

	changeHandler = layout => {
	  this.setState({ layout });
	  this.props.updateSettingsHandler({
	    layout
	  })
	}

	render() {
	  const { t, imageCount } = this.props;
	  const layouts = ['default'].concat(imageLayouts[Math.min(4, imageCount)]);

	  return (
	    <Container>
	      <Label>{t('controls/common/settings/layout')}</Label>

	      {layouts.map(layout => (
	        <Slot
	          key={layout}
	          active={layout === this.state.layout}
	          onClick={() => this.changeHandler(layout)}
	        >
	          <LayoutThumbnail data={this.props.data.map(image => ({
	            url: image.conversions.xs,
	            position: image.position,
	            scale: image.scale,
	            size: image.size,
	            file: image.file,
	          }))} layout={layout} />
	        </Slot>
	      ))}
	    </Container>
	  )
	}
}

Layout.propTypes = {
	t: PropTypes.func,
	data: PropTypes.array,
	imageCount: PropTypes.number,
	updateSettingsHandler: PropTypes.func,
	layout: PropTypes.string,
}

export default translate('translations')(Layout)
